export const DATA_HOOKS = {
  CALENDAR: 'calendar',
};
